import React from 'react';
import { useNavigate } from 'react-router-dom';

const currentYear = new Date().getFullYear().toString();

const Footer = () => {
    const nav = useNavigate();
    const goPolicy = (r) => {
        nav(r);
    };

    return (
        <div className="bg-white border-t border-gray-200 py-6 px-4 sm:px-6 lg:px-8">
            <div className="max-w-full mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                    {/* Left Column - Copyright */}
                    <div className="text-sm text-gray-600 text-center md:text-left">
                        <span>© {currentYear}, VintanaLabs Sdn Bhd (201901000787 (1310113-H))</span>
                    </div>

                    {/* Right Column - Links */}
                    <div className="flex flex-col sm:flex-row gap-4 sm:gap- justify-center md:justify-end text-center md:text-right">
                        <button
                            className="text-sm text-gray-600 hover:text-gray-800 active:text-gray-800 hover:underline active:underline transition-colors touch-manipulation"
                            onClick={() => goPolicy('/footer-primary-links/warranty-terms')}
                        >
                            Warranty Terms and Conditions
                        </button>
                        <button
                            className="text-sm text-gray-600 hover:text-gray-800 active:text-gray-800 hover:underline active:underline transition-colors touch-manipulation"
                            onClick={() => goPolicy('/footer-primary-links/privacy-policy')}
                        >
                            Privacy Policy
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
